import { atom } from 'recoil';
import type { ICounterState, ILayoutState, IWindowSizeState } from './ICounterState';

export const textCounterAtom = atom<ICounterState>({
  key: 'textCounterAtom',
  default: {
    charCountType: 1,
    newlineCountType: 1,
    isSkipWhitespacee: true,
    content: '',
  },
});

export const windowSizeAtom = atom<IWindowSizeState>({
  key: 'windowSizeAtom',
  default: {
    width: 100,
    height: 100,
  },
});

export const textLayoutAtom = atom<ILayoutState>({
  key: 'textLayoutAtom',
  default: {
    maxRowSize: 7,
    maxColSize: 1,
    letters: [[''], [''], [''], [''], [''], [''], ['']],
    character: {
      margin: {
        left: 20,
        right: 20,
      },
      widths: [],
      heights: [],
    },
  },
});
